import React from 'react';
import PropTypes from 'prop-types';

import Drm from 'Components/Utility/Drm';

function MultiDrm({ drm, ...props }) {
  const drmArray = Object.keys(drm).filter(d => drm[d]);

  return (
    <div className="multiDrm d-flex">
      {drmArray.map(drmType =>
        <Drm key={drmType} drmType={drmType} {...props} />,
      )}
    </div>
  );
}

MultiDrm.propTypes = {
  drm: PropTypes.shape({}).isRequired,
};

export default MultiDrm;
